import {
  FieldType,
  SortOrderType,
  FilterByField,
} from '../../api/graphql/generated';
import { useState } from 'react';
import { useTerminals } from '../../components/core/hooks/get-terminals-hook';
import { COLUMNDEFINITIONS } from '../reports/usagesummary/components/usage-summary-column-definitions';

import {
  Container,
  BarChart,
  Box,
  SpaceBetween,
  Header,
  Table,
} from '@cloudscape-design/components';

export namespace Field {
  export function fromString(field: string): FieldType {
    return (FieldType as any)[field];
  }
}

export default () => {
  const [limit] = useState(5);
  const [page] = useState(1);
  const fields = [
    FieldType.TerminalId,
    FieldType.TerminalName,
    FieldType.CompanyName,
    FieldType.NetworkName,
  ];
  const [sort] = useState([
    { sort_by: FieldType.TotalBytes, sort_order: SortOrderType.Desc },
  ]);

  const filterByFields: FilterByField[] = [];
  const [dateStart] = useState(() => {
    const startDateReturn = new Date();
    startDateReturn.setUTCDate(1);
    startDateReturn.setUTCHours(0, 0, 0);
    return startDateReturn;
  });
  const [dateEnd] = useState(
    new Date(new Date().setUTCDate(new Date().getDate()))
  );
  const { items } = useTerminals({
    queryLimit: limit,
    queryPage: page,
    queryFields: fields,
    querySort: sort,
    querySearch: '',
    queryFilterByFields: filterByFields,
    queryStartDate: dateStart,
    queryEndDate: dateEnd,
  });
  console.log(items);
  const chartData = items.map((item) => ({
    x: item.TerminalId,
    y: item.TotalBytes,
  }));
  const xDomain = items.map((item) => item.TerminalId);

  return (
    <SpaceBetween size='m'>
      <Container
        header={
          <Header variant='h2'>5 Terminals Using Most Data This Month</Header>
        }
      >
        <div>
          <BarChart
            series={[
              {
                title: 'Terminal Usage',
                type: 'bar',
                // @ts-ignore
                data: chartData,
                valueFormatter: function o(e) {
                  return Math.abs(e) >= 1e9
                    ? (e / 1e9).toFixed(4) + ' GB'
                    : Math.abs(e) >= 1e6
                    ? (e / 1e6).toFixed(4) + ' MB'
                    : Math.abs(e) >= 1e3
                    ? (e / 1e3).toFixed(4) + ' KB'
                    : e.toFixed(0);
                },
              },
              {
                title: 'Threshold',
                type: 'threshold',
                y: 5000000,
                valueFormatter: (e) => (e / 1e6).toFixed(0) + ' MB',
              },
            ]}
            xDomain={xDomain}
            yDomain={[0, 30000000]}
            i18nStrings={{
              xTickFormatter: (e) => 'TI-' + e.toString(),
              yTickFormatter: function o(e) {
                return Math.abs(e) >= 1e9
                  ? (e / 1e9).toFixed(0) + ' GB'
                  : Math.abs(e) >= 1e6
                  ? (e / 1e6).toFixed(0) + ' MB'
                  : Math.abs(e) >= 1e3
                  ? (e / 1e3).toFixed(0) + ' KB'
                  : e.toFixed(0);
              },
            }}
            ariaLabel='Single data series line chart'
            height={300}
            hideFilter
            xTitle='Terminal ID'
            yTitle='Total Usage'
            empty={
              <Box textAlign='center' color='inherit'>
                <b>No data available</b>
                <Box variant='p' color='inherit'>
                  There is no data available
                </Box>
              </Box>
            }
            noMatch={
              <Box textAlign='center' color='inherit'>
                <b>No matching data</b>
                <Box variant='p' color='inherit'>
                  There is no matching data to display
                </Box>
              </Box>
            }
          />
        </div>
      </Container>
      <Table
        columnDefinitions={COLUMNDEFINITIONS}
        items={items}
        resizableColumns={true}
        columnDisplay={[
          { id: 'TerminalId', visible: true },
          { id: 'RxBytes', visible: true },
          { id: 'TxBytes', visible: true },
          { id: 'TotalBytes', visible: true },
          { id: 'TerminalName', visible: true },
          { id: 'NetworkName', visible: true },
        ]}
        loadingText='Loading resources'
        trackBy='name'
        header={<Header></Header>}
      />
    </SpaceBetween>
  );
};
